<lib-overlayer
  popUpID="voip-credentials-modal"
  [displaySubTitle]="false"
  [displayFooter]="false"
  [options]="{ backDrop: true, closeViaBackdrop: true }"
  [showModal]="open"
  (onClose)="onClose()"
>
  <ng-container Title>
    {{ "modem-choice.voip-generate-title" | translate }}
  </ng-container>
  <ng-container Content>
    <p>
      {{ "modem-choice.voip-generate-description" | translate }}
    </p>
    <div class="row">
      <div *ngIf="credentials; else loading" class="columns small-12 medium-8">
        <div class="rs-flex-row rs-flex-middle">
          <div class="rs-flex-column">
            <div class="rs-form-items-group rs-form-items-group-collapse">
              <div class="rs-form-item">
                <input
                  type="text"
                  id="ac-login"
                  class="rs-filled"
                  [value]="credentials.login"
                  readonly
                />
                <label for="ac-login">
                  {{ "modem-choice.voip-generate-login" | translate }}
                </label>
              </div>
              <div class="rs-form-btn">
                <button
                  class="rs-btn"
                  data-tooltip
                  [title]="'modem-choice.voip-generate-login-copy' | translate"
                  [attr.aria-label]="
                    'modem-choice.voip-generate-login-copy' | translate
                  "
                  (click)="onCopy(credentials.login)"
                >
                  <i class="icon-Copy" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="rs-flex-row rs-flex-middle">
          <div class="rs-flex-column">
            <div class="rs-form-items-group rs-form-items-group-collapse">
              <div class="rs-form-item">
                <input
                  type="text"
                  id="ac-password"
                  class="rs-filled"
                  [value]="credentials.password"
                  readonly
                />
                <label for="ac-password">
                  {{ "modem-choice.voip-generate-password" | translate }}
                </label>
              </div>
              <div class="rs-form-btn">
                <button
                  class="rs-btn"
                  data-tooltip
                  [title]="
                    'modem-choice.voip-generate-password-copy' | translate
                  "
                  [attr.aria-label]="
                    'modem-choice.voip-generate-password-copy' | translate
                  "
                  (click)="onCopy(credentials.password)"
                >
                  <i class="icon-Copy" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="rs-txt-s3 rs-txt-details">
      {{ "modem-choice.voip-generate-helper" | translate }}
    </p>
  </ng-container>
</lib-overlayer>

<ng-template #loading>
  <div class="columns small-12 medium-8">
    <div
      role="alert"
      aria-live="polite"
      [attr.aria-label]="'common.loading' | translate"
      aria-busy="true"
    >
      <div class="rs-spinner rs-no-margin-left"></div>
    </div>
  </div>
</ng-template>
